import { useQuery } from "@tanstack/react-query";
import {
  fetchPreferenceBrands,
  type PreferenceBrand,
} from "../services/typesense-preference-brands";
import useUIPreferencesStore from "@/store/use-ui-preferences-store";
import useAuthStore from "@/store/use-auth-store";

export const usePreferenceBrands = (limit: number = 200) => {
  const language = useUIPreferencesStore((state) => state.language);
  const region = useAuthStore((state) => state.user?.region || "");

  return useQuery<PreferenceBrand[]>({
    queryKey: ["preferences", "typesense-brands", limit, language, region],
    queryFn: async () => {
      return await fetchPreferenceBrands({ limit, language, region });
    },
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    retry: 1,
  });
};
